function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 2048 2048"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1564.2 483.7c-298.4-298.2-782.1-298.2-1080.5 0s-298.4 782.1 0 1080.5 782.3 298.2 1080.5 0c298.4-298.2 298.4-782.3 0-1080.5m-404 23.6-33.6 703.7H929.4l-33.6-703.7zM1028 1638.6c-82.9 0-150.1-67.2-150.1-150.1s67.2-150.1 150.1-150.1 150.1 67.2 150.1 150.1c-.1 82.9-67.2 150.1-150.1 150.1",
  style: {
    fill: "#e72635"
  }
}));
export default SvgError;